export var BANK_TRANSACTIONS_SUBSCRIBE = 1;
export var BANK_TRANSACTIONS_UNSUBSCRIBE = 2;
